module.exports = __webpack_public_path__ + "static/blog-img3-b4360e15d585bbcfd68d4ae9d09bc180.png";